import styled, { css } from 'styled-components';

export const TabsWrapper = styled.div`
  position: relative;
  @media ${(props) => props.theme.device.mobileL} {
    margin-left: -16px;
    width: var(--full-width);
  }
`;

export const TabsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['items', 'mb'].includes(prop),
})`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ mb }) => mb}px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 0;
  scrollbar-width: none; //hides the scrollbar without disabling scroll
  &::-webkit-scrollbar {
    display: none;
  }

  &.secondary {
    > div {
      min-height: 60px;
      line-height: 60px;
      padding-bottom: 0;
      border-left: 1px solid #eeeeee;

      ${({ items }) =>
        items &&
        css`
          width: ${100 / items}%;
        `};

      &:last-child {
        border-right: 1px solid #eeeeee;
      }
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    justify-content: flex-start;
    margin-bottom: 24px;
  }
`;
export const Border = styled.div`
  width: 100%;
  height: 2px;
  background: ${(props) => props.theme.colors.border};
  position: absolute;
  top: 29px;
  left: 0;
  z-index: 0;

  &.secondary {
    top: 56px;
  }

  &.tertiary {
    display: none;
  }

  @media ${(props) => props.theme.device.mobileL} {
    top: unset;
    bottom: 0;
  }
`;

export const TabItem = styled.button.withConfig({
  shouldForwardProp: (prop) => !['tabsNumber'].includes(prop),
})`
  position: relative;
  width: ${({ tabsNumber }) =>
    tabsNumber ? `max(${100 / tabsNumber}%, 150px)` : '150px'};
  min-width: fit-content;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.link};
  padding: 0 20px 9px;
  margin-bottom: -2px;
  cursor: pointer;

  svg {
    margin-left: 10px;

    @media ${(props) => props.theme.device.mobileL} {
      margin: auto;
      display: block;
    }
  }
  &.completed {
    background: #e3e3e3;
    color: #646464;
  }
  &.active {
    font-weight: 600;
    background: unset;
    color: ${(props) => props.theme.colors.link};

    svg {
      stroke: ${(props) => props.theme.colors.focusSelect};
    }
  }

  .active-border {
    position: absolute;
    width: 100%;
    height: 2px;
    background: ${(props) => props.theme.colors.focusSelect};
    bottom: 2px;
    left: 0;
    z-index: 1;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: ${(props) => props.theme.colors.textPrimary};
    `}

  // tutor tabs
    &.tertiary {
    display: flex;
    column-gap: 8px;
    margin-bottom: 16px;
    text-align: left;
    border-right: 1px solid ${(props) => props.theme.colors.border};

    > span {
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }

    &.active > span {
      color: ${(props) => props.theme.colors.focusSelect};
    }

    .active-border {
      bottom: -16px;
    }

    .icon-check-circle {
      margin-left: auto;
      display: inline-block;
    }

    .edit {
      position: absolute;
      bottom: -15px;
    }
  }
`;
